import React from "react";
import { Link } from "react-router-dom";
import "./style.css";

const Footer = (props) => {
  return (
    <footer className="global-footer">
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-brand">
            <h3>
              <img src="/assets/logo.jpg" alt="秒应" style={{ width: 28, height: 28, borderRadius: 6, objectFit: "cover", display: "inline-block", verticalAlign: "middle", marginRight: 6 }} />
              秒应
            </h3>
            <p>群接龙打卡报名神器，老师、班委、行政都在用。<br />省时省力不刷屏，数据自动汇总导出。</p>
          </div>
          <div className="footer-cols">
            <div className="footer-col">
              <h4>产品</h4>
              <ul>
                <li><a href="/#features">功能介绍</a></li>
                <li><Link to="/tutorials" style={{ display: "none" }}>使用教程</Link></li>
                <li><Link to="/changelog" style={{ display: "none" }}>更新日志</Link></li>
              </ul>
            </div>
            <div className="footer-col">
              <h4>支持</h4>
              <ul>
                <li><Link to="/helpcenter">帮助中心</Link></li>
                <li><Link to="/videos" style={{ display: "none" }}>视频教程</Link></li>
                <li><Link to="/contact">联系我们</Link></li>
              </ul>
            </div>
            <div className="footer-col">
              <h4>关于</h4>
              <ul>
                <li><Link to="/about">关于我们</Link></li>
                <li><Link to="/terms">用户协议</Link></li>
                <li><Link to="/privacy" style={{ display: "none" }}>隐私政策</Link></li>
              </ul>
            </div>
          </div>
        </div>
        <div className="footer-bottom">
          <p>
            <a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank" rel="noopener noreferrer" style={{ color: "#94a3b8", textDecoration: "none" }}>
              © 2026 积致科技（北京）有限公司 京ICP备2021004350号-2
            </a>
          </p>
          <p style={{ marginTop: 6 }}>秒应 | 教育部备案 | 阿里云数据支持</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
